import { render, staticRenderFns } from "./sg-sst.vue?vue&type=template&id=52f54112&"
import script from "./sg-sst.vue?vue&type=script&lang=js&"
export * from "./sg-sst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports